// btw-front/src/api/adminDealReviews.js
// 관리자 [딜 심사] 탭 API — 파트너가 올린 딜은 승인을 받아야 활성 딜이 된다.
import { api } from "./client";

// 심사 목록. status 미지정이면 심사 대기.
//   pending  — 오래 기다린 순(먼저 올린 파트너가 먼저 처리되도록)
//   done — 승인+반려 묶음([처리 완료] 탭). approved / rejected 는 한쪽만.
//     전부 최근 심사순이고 **실제로 심사를 거친 건만** 내려온다
//     (승인제 도입 이전 딜은 approved 지만 reviewed_at 이 NULL 이라 서버가 제외한다)
//   반려 딜은 소프트 삭제돼 있어도 포함된다 — 심사 이력이라 [삭제된 딜] 탭과 양쪽에서
//   반려 사유를 볼 수 있어야 한다. 반면 승인 후 따로 삭제한 딜은 제외된다.
// 항목: { id, projectName, customerCompany, customerBusinessNumber, status, poAmount,
//        poExpectedQuarter, salesRepName, partnerMemo, partnerCompanyName, createdByName,
//        reviewStatus, reviewRejectReason, reviewedByName, reviewedAt, submittedAt, daysWaiting }
export async function list(status) {
  const qs = status ? `?status=${encodeURIComponent(status)}` : "";
  const res = await api.get(`/admin/deal-reviews${qs}`);
  return res.items || [];
}

// 승인 — 즉시 활성 딜이 된다(딜 목록·통계·실적에 편입). 심사 대기 건만 가능(그 외 409).
export async function approve(id) {
  return api.post(`/admin/deals/${encodeURIComponent(id)}/review-approve`);
}

// 반려 — 사유 필수(없으면 400). 반려 딜은 고객사 선점을 놓아 다른 파트너사가 등록할 수 있다.
export async function reject(id, reason) {
  return api.post(`/admin/deals/${encodeURIComponent(id)}/review-reject`, { reason });
}
